const DriversSpeed = () =>
  import(
    /* webpackChunkName: "location-location-speed" */ '@/pages/location/location/driver-speed.vue'
  )

export default {
  path: 'driver-speed',
  meta: {
    label: 'SpeedDrivers',
    auth: 'speed'
  },
  component: {
    name: 'Speed',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'GeoLocationDriverSpeed',
      path: '',
      meta: {
        label: 'report',
        auth: true
      },
      component: DriversSpeed
    }
  ]
}
